// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol, OnAfterCodeLoad, HasChangedInternallySymbol } from "@lg/shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => CompanyNameMatchingOutputType.loadInternal(), entryList => {
        CompanyNameMatchingOutputType.θentryList.set(entryList)
        CompanyNameMatchingOutputType.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class CompanyNameMatchingOutputType {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<CompanyNameMatchingOutputType.Id | null>;
    static readonly Id = String;
    static ids: CompanyNameMatchingOutputType.Id[] = [] as any;
    static idsAndDisplayValues: Record<CompanyNameMatchingOutputType.Id, string> = {} as any;
    static θentryList = signal<CompanyNameMatchingOutputType.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<CompanyNameMatchingOutputType.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? CompanyNameMatchingOutputType.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return CompanyNameMatchingOutputType[BoInfoSymbol]
    }

    get __type(): 'Toolbox.CompanyNameMatchingOutputType' {
        return 'Toolbox.CompanyNameMatchingOutputType'
    }

    set __type(_) {
    }

    static get __type(): 'Toolbox.CompanyNameMatchingOutputType' {
        return 'Toolbox.CompanyNameMatchingOutputType'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): CompanyNameMatchingOutputType.Id | null {
        return this.θid()
    }

    set id(id: CompanyNameMatchingOutputType.Id | CompanyNameMatchingOutputType | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !CompanyNameMatchingOutputType.getEntry(id as CompanyNameMatchingOutputType.Id)) throw new Error('Invalid id for type Toolbox.CompanyNameMatchingOutputType: ' + id)
        this.θid.set(id as CompanyNameMatchingOutputType.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): CompanyNameMatchingOutputType.Id[] {
        return CompanyNameMatchingOutputType.ids
    }

    get idsAndDisplayValues(): Record<CompanyNameMatchingOutputType.Id, string> {
        return CompanyNameMatchingOutputType.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[CompanyNameMatchingOutputType.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isOnlyId() {
        return this.id == 'id'
    }

    static get OnlyId() {
        return new this('id')
    }

    get isOnlyName() {
        return this.id == 'name'
    }

    static get OnlyName() {
        return new this('name')
    }

    get isIdAndName() {
        return this.id == 'idAndName'
    }

    static get IdAndName() {
        return new this('idAndName')
    }

    constructor(idOrObject: CompanyNameMatchingOutputType.Id | CompanyNameMatchingOutputType | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): CompanyNameMatchingOutputType.Entry[] {
        return This.CompanyNameMatchingOutputType.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): CompanyNameMatchingOutputType.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: CompanyNameMatchingOutputType.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof CompanyNameMatchingOutputType.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = CompanyNameMatchingOutputType.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<CompanyNameMatchingOutputType.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return LowgileDataUtil.createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new CompanyNameMatchingOutputType(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: CompanyNameMatchingOutputType.Id | CompanyNameMatchingOutputType | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as CompanyNameMatchingOutputType.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: CompanyNameMatchingOutputType.Id | CompanyNameMatchingOutputType) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<CompanyNameMatchingOutputType.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Toolbox.CompanyNameMatchingOutputType yet:', err.message)
            //throw err
        })
    }

    static $getSchema() {
        return z.string()
    }

    $getSchema() {
        return z.string()
    }

    setOnlyId() {
        this.id = 'id'

    }

    setOnlyName() {
        this.id = 'name'

    }

    setIdAndName() {
        this.id = 'idAndName'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "id", label: "Id" }),
            Object.freeze({ id: "name", label: "Name" }),
            Object.freeze({ id: "idAndName", label: "Id and name" })
        ] as CompanyNameMatchingOutputType.Entry[]) as CompanyNameMatchingOutputType.Entry[]
    }
}
jsonClass('Toolbox.CompanyNameMatchingOutputType')(CompanyNameMatchingOutputType)

export const CompanyNameMatchingOutputTypeθId = String;

export type CompanyNameMatchingOutputTypeθId = string;

export namespace CompanyNameMatchingOutputType {
    export type Id = 'id' | 'name' | 'idAndName'

    export interface Entry {
        id: CompanyNameMatchingOutputType.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => CompanyNameMatchingOutputType.load(true))
